import { ILocation, ISite } from "../types/SiteLocation.types";
import apiFetch from './index';

export async function saveSite(site: ISite) {
    let url = '/api/sites';
    if (site.Id !== undefined && site.Id !== -1) {
        url += '/' + site.Id;
    }
    return await apiFetch(url, {
        method: 'POST',
        body: JSON.stringify(site),
        headers: {
            Accept: 'application/json',
            'Content-Type' : 'application/json'
        },
        credentials: 'include'
    });
}

export async function deleteSite(id: number) {
    return await apiFetch(`/api/sites/${id}`, {
        method: 'DELETE',
        headers: {
            Accept: 'application/json',
        },
        credentials: 'include'
    });
}

export async function getSite(id: number) {
    return await apiFetch(`/api/sites/${id}`, {
        headers: {
            Accept: 'application/json',
        },
        credentials: 'include'
    });
}

export async function getDeskSites(abortController?: AbortController) {
    const response = await apiFetch('/api/sites/desks', {
        headers: {
            Accept: 'application/json',
        },
        credentials: 'include',
        signal: abortController?.signal
    });
    return response;
}

export async function getSites(abortController?: AbortController) {
    const response = await apiFetch('/api/sites', {
        headers: {
            Accept: 'application/json',
        },
        credentials: 'include',
        signal: abortController?.signal
    });
    return response;
}

export async function getMySites(abortController?: AbortController) {
    const response = await apiFetch(`/api/sites/my`, {
        headers: {
            Accept: 'application/json',
        },
        credentials: 'include',
        signal: abortController?.signal
    });
    return response;
}

export async function saveLocation(location: ILocation) {
    let url: string;
    if (location.Id !== undefined && location.Id !== -1) {
        url = `/api/locations/${location.Id}`;
    } else {
        url = `/api/locations/site/${location.SiteId}`;
    }
    return await apiFetch(url, {
        method: 'POST',
        body: JSON.stringify(location),
        headers: {
            Accept: 'application/json',
            'Content-Type' : 'application/json'
        },
        credentials: 'include'
    });
}

export async function deleteLocation(id: number) {
    return await apiFetch(`/api/locations/${id}`, {
        method: 'DELETE',
        headers: {
            Accept: 'application/json',
        },
        credentials: 'include'
    });
}

export async function getLocation(id: number) {
    return await apiFetch(`/api/locations/${id}`, {
        headers: {
            Accept: 'application/json',
        },
        credentials: 'include'
    });
}

export async function loadLocations(id: number, deskCheck?: boolean) {
    const response = await apiFetch(`/api/locations/site/${id}${deskCheck ? '/desks' : ''}`, {
        headers: {
            Accept: 'application/json',
        },
        credentials: 'include'
    });
    return response;
}